import _ from "lodash";
import {standard} from "felles/stoettefunk/nillsjekk";


/** Sann dersom angitt liste er tom eller nill */
export function erTomListe<T>(liste: T[] | null): boolean {
    return _.isEmpty(liste)
}

/** Sann dersom angitt liste er en IKKE-tom listen (array) */
export function erIkkeTomListe<T>(liste: T[] | null): boolean {
    return !erTomListe(liste) && _.isArray(liste)
}

/**
 * Bytter plass mellom elementet på posisjonA og posisjonB
 *
 * MERK: funksjonen muterer listen som sendes inn.
 */
export function rokker<T>(liste: T[], posisjonA: number, posisjonB: number): T[] {
    var element = liste[posisjonA];
    liste[posisjonA] = liste[posisjonB];
    liste[posisjonB] = element;
    return liste;
}

/**
 * Flytter element i listen fra angitt fraPosisjon til angitt tilPosisjon.
 *
 * MERK: funksjonen muterer listen som sendes inn.
 */
export function flytt<T>(liste: T[], fraPosisjon: number, tilPosisjon: number): void {
    var element = liste[fraPosisjon];
    liste.splice(fraPosisjon, 1);
    liste.splice(tilPosisjon, 0, element);
}

export function kopier<T>(liste: T[]): T[] {
    return liste.slice();
}

export function reverser<T>(liste: T[]): T[] {
    var kopi = kopier(liste);
    kopi.reverse();
    return kopi;
}

/** Erstatter element som matcher angitt predikat med angitt oppdatertElement i angitt liste, returnerer listen. */
export function erstatt<T>(liste: T[], oppdatertElement: T, predikat: _.ListIterator<T, boolean>): T[] {
    var index = _(liste).findIndex(predikat);
    if (index == -1) return liste;

    liste[index] = oppdatertElement;
    return liste;
}

/** Returnerer sann dersom listene er like uten å ta hensyn til rekkefølge på elementene.
 * dersom begge listene er null returnerer sann */
export function erLikIgnorerRekkefølge<T>(a: T[], b: T[]): boolean {
    if (a == null && b == null) return true;
    return _.xor(a, b).length == 0
}

/** Returnerer angitt liste derom denne er ikke-null, eller en tom liste */
export function nullSikkerListe<T>(liste: T[] | null): T[] {
    return standard(liste, []);
}

/** Returnerer siste innslag i angitt liste, eller null dersom listen er tom eller null */
export function siste<T>(liste: T[]): T | null {
    return erIkkeTomListe(liste) ? liste[liste.length - 1] : null;
}

/** Returnerer første innslag i angitt liste, eller null dersom listen er tom eller null */
export function første<T>(liste: T[]): T | null {
    return erIkkeTomListe(liste) ? liste[0] : null;
}
